import dayjs from 'dayjs'
import 'dayjs/locale/zh-tw'
import { stCarrierToName } from '../utils'
const relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(relativeTime)
dayjs.locale('zh-tw')

export function dateFormat (v, formatStr = 'YYYY-MM-DD HH:mm:ss') {
  if (v == null) return v
  if (v === '0000-00-00 00:00:00') return ''
  if (v === '0') return ''
  if (!isNaN(v) && v.length === 10) {
    v = parseInt(v) * 1000
  }
  return dayjs(v).format(formatStr)
}

export function fromNow (v) {
  return dayjs(v).fromNow()
}

// 预定义的裁剪参数
const gmkerlMap = {
  productImg: '!/both/400x400',
  tbk120: '!tbk120',
  tbk800: '!tbk800'
}
export function upyun (v, gmkerl) {
  if (v === null || v === undefined) {
    return v
  }
  if (/^https?:/.test(v)) {
    // let userAgent = navigator.userAgent
    // if (userAgent.indexOf('Firefox') > -1) {
    //   let str = v.substring(0, v.length - 6)
    //   return str
    // }
    return v
  } else if (/^\/\//.test(v)) {
    return v
  }
  if (gmkerlMap[gmkerl]) {
    gmkerl = gmkerlMap[gmkerl]
  }
  return `//jyb.upjyb.l-qian.cn${v}${gmkerl || ''}`
}

export function toKg (value, decimal = 2) {
  return isNaN(value) ? value : Number((value / 1000).toFixed(decimal))
}

export function ccmss3 (v) {
  return `https://ccmss3.jyb.com.tw/${v}`
}

export function valToNameByArray (v, items) {
  const item = items.find(item => String(item.value) === String(v))
  if (!item) return v
  return item.text
}

export default function (Vue) {
  Vue.filter('upyun', upyun)
  Vue.filter('stCarrierToName', stCarrierToName)
  Vue.filter('dateFormat', dateFormat)
  Vue.filter('fromNow', fromNow)
  Vue.filter('toKg', toKg)
  Vue.filter('ccmss3', ccmss3)
  Vue.filter('valToNameByArray', valToNameByArray)
}



// WEBPACK FOOTER //
// ./src/filters/index.js